import { useState } from 'react';
import api from '../api';
import { useApp } from '../App';

export default function OfferAccept() {
  const { setPage } = useApp();
  const [externalLeadRef, setExternalLeadRef] = useState('');
  const [externalDealRef, setExternalDealRef] = useState('');
  const [dealAmount, setDealAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const offerId = Number(localStorage.getItem('marketplace_offer_id') || 0);

  async function onSubmit(e) {
    e.preventDefault();
    if (!offerId) {
      setError('Оффер не выбран');
      return;
    }
    try {
      setLoading(true);
      setError('');
      const { data } = await api.post(`/marketplace/offers/${offerId}/accept`, {
        external_lead_ref: externalLeadRef || null,
        external_deal_ref: externalDealRef || null,
        deal_amount: dealAmount ? Number(dealAmount) : null,
      });
      setResult(data);
    } catch (e2) {
      setError(e2.userMessage || e2.response?.data?.detail || 'Не удалось принять оффер');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="page-header">Accept offer</div>
      <div className="card">
        <form onSubmit={onSubmit} style={{ display: 'grid', gap: 10 }}>
          <label>
            Lead ref (optional)
            <input className="input" value={externalLeadRef} onChange={(e) => setExternalLeadRef(e.target.value)} placeholder="lead-123" />
          </label>

          <label>
            Deal ref (optional)
            <input className="input" value={externalDealRef} onChange={(e) => setExternalDealRef(e.target.value)} placeholder="deal-456" />
          </label>

          <label>
            Deal amount (optional)
            <input className="input" type="number" step="0.01" value={dealAmount} onChange={(e) => setDealAmount(e.target.value)} placeholder="1000" />
          </label>

          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button type="button" className="btn" onClick={() => setPage('offer_details')}>← Назад</button>
            <button type="button" className="btn" onClick={() => window.open('https://genro.ai', '_blank', 'noopener,noreferrer')}>Open in Genro AI</button>
            <button disabled={loading} type="submit" className="btn btn-primary">{loading ? 'Отправка...' : 'Process in Workify CRM'}</button>
          </div>
        </form>

        {error && <div style={{ color: '#ef4444', marginTop: 10 }}>{error}</div>}

        {result && (
          <div style={{ marginTop: 12, padding: 10, border: '1px solid rgba(16,185,129,0.35)', borderRadius: 10 }}>
            ✅ Accepted: acceptance #{result.acceptance_id}, lead #{result.lead_id}, deal #{result.deal_id}
          </div>
        )}
      </div>
    </div>
  );
}
